module.exports = __webpack_public_path__ + "img/800-fill-power.6418213.svg";